import { render } from "./GameError.vue?vue&type=template&id=094e9ea8"
import script from "./GameError.vue?vue&type=script&lang=ts"
export * from "./GameError.vue?vue&type=script&lang=ts"
script.render = render

export default script